import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            视频分类浏览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类别发现你感兴趣的内容，总有一款适合你
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-secondary-300 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 group-hover:bg-secondary-200 transition-colors">
                <i className={`${category.icon} text-secondary-600 text-xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm font-medium text-foreground-800 whitespace-nowrap">{category.name}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{category.count.toLocaleString()} 个资源</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}